import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'utils/axiosUtil';
import { KARTE_INFO, KARTE_LIST, TIRE_STORAGE_LIMIT_SEARCH } from 'constants/apiURL';
import { loadingActions } from 'slices/loadingSlice';

const initialState = {
  karteInfo: {},
  selectedSrySeq: null,
  showDetailModal: false,
  karteInfoDetail: null,
  tireContractDate: null,
  tireContractAlert: false,
};

export const fetchKarteInfo = createAsyncThunk(
  'fetchKarteInfo',
  async (params, { dispatch }) => {
    dispatch(loadingActions.setPrimaryLoading(true));

    const karteRes = await axios.post(KARTE_LIST, params.karteParams);
    let tireRes = null;
    if(params.isTireContract) {
      tireRes = await axios.post(TIRE_STORAGE_LIMIT_SEARCH, params.tireStorageParams);
    }
    tireRes = tireRes?.body;
    dispatch(loadingActions.setPrimaryLoading(false));

    return { karteRes, tireRes };
  }
);
export const fetchKarteInfoDetail = createAsyncThunk(
  'fetchKarteInfoDetail',
  async params => {
    const res = await axios.post(KARTE_INFO, {
      kaiincrdNo: params.cardNumber,
      srySeq: params.selectedSrySeq,
      partId: params.partId,
    });
    return { ...params, ...res.body };
  }
);

export const karteSlice = createSlice({
  name: 'karteSlice',
  initialState,
  reducers: {
    setSelectedSrySeq: (state, { payload }) => {
      state.selectedSrySeq = payload;
    },
    showDetailModal: (state, { payload }) => {
      state.showDetailModal = true;
      state.karteInfoDetail = payload;
    },
    closeDetailModal: state => {
      state.showDetailModal = false;
      state.karteInfoDetail = null;
    },
    clear: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchKarteInfo.fulfilled, (state, { payload }) => {
      state.karteInfo = payload.karteRes.body;
      state.tireContractDate = payload?.tireRes?.tireStorageLimitDate;
      state.tireContractAlert = payload?.tireRes?.tireStorageAlert === '1';
    });
    builder.addCase(fetchKarteInfoDetail.fulfilled, (state, { payload }) => {
      state.showDetailModal = true;
      state.karteInfoDetail = payload;
    });
  },
});

export const actions = karteSlice.actions;
export default karteSlice.reducer;
